/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement, useContext } from "react"
import { UseFormReturn } from "react-hook-form"

import BaseFormGenerator from "./baseFormGenerator"
import { BELFAST_POST_CODE_AREA } from "../../../../../constants/generalConstants"
import { IFormProperties } from "../../../../../services/middleware/types/singleApplication/getSchemaTypes"
import { ApplicationContext } from "../../applicationProvider"
import { POSTCODE_KW } from "../../recognisedInputs/addressForm"

interface IBasicFormGeneratorProps {
    formKey: string
    formProperties: IFormProperties
}

/**
 * Basic form builder for the installer application.
 */
const InstallerApplicationBasicFormBuilder = ({
    formKey,
    formProperties,
}: IBasicFormGeneratorProps): ReactElement => {
    const {
        setFormData,
        setCurrentStepIndex,
        formData,
        setJurisdiction,
        isFirstStep,
        onClickBackFirstStep,
        isAmendmentMode,
        jurisdiction,
    } = useContext(ApplicationContext)

    const getJurisdictionFromPostcode = (postcode?: any): "GB" | "NI" =>
        postcode?.toLowerCase().startsWith(BELFAST_POST_CODE_AREA) ? "NI" : "GB"

    const onClickNextSideEffect = (methods: UseFormReturn): void => {
        if (formKey === "installerCustomerDetails") {
            const customerDetails = formData.installerCustomerDetails
            let postcode

            // Check if it's an array
            if (Array.isArray(customerDetails)) {
                // Example: Find an item with a specific key
                postcode = customerDetails.find(
                    (item) => item.key === POSTCODE_KW
                )
            } else {
                // Access specific properties safely with optional chaining
                postcode =
                    customerDetails?.postcode ||
                    customerDetails?.installationPostCode
            }
            const jurisdictionCode = getJurisdictionFromPostcode(postcode)
            setJurisdiction(jurisdictionCode)
        }
    }

    return (
        <BaseFormGenerator
            formKey={formKey}
            formProperties={formProperties}
            formData={formData}
            setFormData={setFormData}
            setCurrentStepIndex={setCurrentStepIndex}
            onClickNextSideEffect={onClickNextSideEffect}
            isFirstStep={isFirstStep}
            onClickBackFirstStep={onClickBackFirstStep}
            isAmendment={isAmendmentMode}
            firstStepNameOverride="Start Again"
        />
    )
}

export default InstallerApplicationBasicFormBuilder
